(() => {
 'use strict';
 const $=(s,r=document)=>r.querySelector(s);
 const money=v=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:window.MDMTheme?.currency || 'EUR'}).format(v/100);
 const products=Array.isArray(window.MDM_PRODUCTS)?window.MDM_PRODUCTS:[];
 const page=$('[data-generic-product].generic-product');
 if(page){
  const product=products.find(p=>p.handle===page.dataset.genericProduct);
  if(product){
   const isPack=page.dataset.productFamily==='pack';
   const picker=$('#product-variant');
   const complement=$('#complement-variant');
   const first=product.variants.find(v=>v.available)||product.variants[0];
   const variants=new Map(products.flatMap(p=>p.variants.map(v=>[v.id,{...v,product:p}])));
   function selection(){
    const main=product.variants.find(v=>v.id===(picker?.value||first.id))||first;
    const pair=$('input[name="generic-offer"]:checked')?.value==='pair';
    const second=variants.get(complement?.value);
    const pairPacks=window.MDM_PAIR_PACKS||{};
    const packId=second&&(pairPacks[main.id+'|'+second.id]||pairPacks[second.id+'|'+main.id]);
    const candidate=variants.get(packId);
    const pack=candidate?.available&&candidate.price<=main.price+second.price?candidate:null;
    return {main,pair,second,pack};
   }
   function update(){
    const {main,pair,second,pack}=selection();
    const pairPrice=pack?pack.price:main.price+(second?.price||0);
    const total=pair?pairPrice:main.price;
    const available=main.available&&(!pair||!!second?.available);
    $('#product-price').textContent=money(total);
    if($('#offer-single-price'))$('#offer-single-price').textContent=money(main.price);
    if($('#offer-pair-price'))$('#offer-pair-price').textContent=money(pairPrice);
    document.querySelectorAll('.generic-offers .offer').forEach(label=>label.classList.toggle('selected',!!$('input',label)?.checked));
    if($('#bundle-complement'))$('#bundle-complement').hidden=!pair;
    const bundleNote=$('#bundle-complement>small');
    const pairHint=$('.generic-offers input[value="pair"]')?.closest('.offer')?.querySelector('small');
    if(pairHint){
     const saving=pack?main.price+second.price-pairPrice:0;
     pairHint.textContent=saving>0?'Économisez '+money(saving):'';
     pairHint.classList.toggle('offer-saving',saving>0);
    }
    if(bundleNote)bundleNote.textContent=pack?(isPack?'Votre sélection':'Votre duo assorti')+' au tarif pack : '+money(pairPrice)+'. Vous économisez '+money(main.price+second.price-pairPrice)+' par rapport aux deux produits séparés.':(isPack?'Le total correspond au coffret et au produit ajouté.':'Le prix du duo correspond à la somme des deux produits.');
    const buy=$('.generic-add');
    buy.disabled=!available;
    $('span',buy).textContent=available?(pair?(isPack?'Ajouter ma sélection au panier':'Ajouter mon duo au panier'):'Ajouter au panier'):'Indisponible pour le moment';
    const availability=$('#product-availability');
    availability.classList.toggle('unavailable',!available);
    availability.lastChild.textContent=available?'Disponible':'Épuisé';
    const delivery=$('[data-delivery-estimate]',page);
    if(delivery)delivery.dataset.available=String(available);
    const sticky=$('.sticky-buy');
    if(sticky){$('span',sticky).firstChild.textContent=pair?(isPack?'Votre sélection':'Votre duo'):product.title;$('#sticky-price').textContent=money(total);}
    document.dispatchEvent(new Event('mdm:product-ready'));
   }
   page.addEventListener('change',e=>{
    if(e.target===picker||e.target===complement||e.target.name==='generic-offer')update();
   });
   $('.generic-add',page)?.addEventListener('click',()=>{
    const {main,pair,second,pack}=selection();
    if(!main.available||pair&&!second?.available)return;
    const quantity=Math.max(1,Math.min(10,Number(document.getElementById('mdm-quantity')?.value)||1));
    const lines=pair&&pack?[{id:pack.id,quantity:quantity}]:[{id:main.id,quantity:quantity}];
    if(pair&&!pack)lines.push({id:second.id,quantity:quantity});
    window.MDMCart?.addMany(lines);
   });
   update();
  }
 }
 const dropdowns=[...document.querySelectorAll('.nav-dropdown')];
 dropdowns.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)dropdowns.filter(x=>x!==d).forEach(x=>x.open=false);}));
 document.addEventListener('click',e=>{
  dropdowns.forEach(d=>{if(!d.contains(e.target)||e.target.closest('a'))d.open=false;});
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape')dropdowns.forEach(d=>d.open=false);});
})();
